export var iconStatusWarning = {
  "children": [{
    "name": "circle",
    "type": "element",
    "value": "",
    "attributes": {
      "cx": "12",
      "cy": "12",
      "r": "6",
      "fill": "#fff"
    },
    "children": []
  }, {
    "name": "path",
    "type": "element",
    "value": "",
    "attributes": {
      "fill": "#FBB01B",
      "d": "M21.586 16.476 14.591 4.498c-1.158-1.983-4.024-1.983-5.182 0L2.414 16.476c-1.169 2 .274 4.513 2.59 4.513h13.992c2.316 0 3.759-2.513 2.59-4.513M11.25 9.73a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-1.5 0zm.75 7.25a1 1 0 1 1 0-2 1 1 0 0 1 0 2"
    },
    "children": []
  }],
  "id": "icon-status-warning",
  "viewBox": "0 0 24 24"
};